<ngx-loading [show]="isProcessing"></ngx-loading>


<div class="row" style="background-color: #fdfdfd;">
  <div class="col-md-12">
    <div class="box box-primary">
      <div class="box-body pt-0">
        <div class="row">
          <div class="col-md-12">
            <div class="box-header text-center">
              <h3 class="box-title">Entradas material do período</h3>
            </div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <fieldset class="border p-4">
                  <legend class="w-auto text-center">
                    Período
                  </legend>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="">Data Inicial</label>
                        <input class="form-control text-center inputDataInicial" type="text"
                          (change)="checkDataValidations()" [textMask]="{ mask: maskData, guide: true }" [ngClass]="{
                            'is-invalid':
                              !this.validations?.inputDataInicialValid ||
                              !this.validations?.inputDataInicialNotEmpty
                          }" />
                        <section *ngIf="!this.validations?.inputDataInicialValid" class="form-text text-danger pl-2">
                          <small>Data inválida</small>
                        </section>
                        <section *ngIf="!this.validations?.inputDataInicialNotEmpty" class="form-text text-danger pl-2">
                          <small><b>Data inicial</b> deve ser informada</small>
                        </section>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="">Data Final</label>
                        <input class="form-control text-center inputDataFinal" type="text"
                          (change)="checkDataValidations()" [textMask]="{ mask: maskData, guide: true }" [ngClass]="{
                            'is-invalid':
                              !this.validations?.dataFinalMaiordataInicial ||
                              !this.validations?.inputDataFinalValid ||
                              !this.validations?.inputDataFinalNotEmpty
                          }" />
                        <section *ngIf="!this.validations?.dataFinalMaiordataInicial"
                          class="form-text text-danger pl-2">
                          <small><b>Data Final</b> deve ser maior que
                            <b>Data Inicial</b></small>
                        </section>

                        <section *ngIf="!this.validations?.inputDataFinalValid" class="form-text text-danger pl-2">
                          <small>Data inválida</small>
                        </section>
                        <section *ngIf="!this.validations?.inputDataFinalNotEmpty" class="form-text text-danger pl-2">
                          <small><b>Data Final</b> deve ser informada</small>
                        </section>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <button type="button" class="btn btn-primary btn-block" (click)="submit()"
                  [disabled]="!this.validations.allFieldsValids()">
                  Consultar
                </button>
              </div>
            </div>
          </div>

        </div>


        <div style="border: 2px solid #ddd; margin-bottom: 15px"></div>

        <section style="height: 380px">
          <section class="animated fadeInDown h300" *ngIf="this.results?.length > 0">
            <div class="row">
              <div class="col-md-12">
                <fieldset class="border p-2 mb-3">
                  <legend class="w-auto txt-blue text-center fs12 fb">
                    Resultado da pesquisa
                  </legend>

                  <div class="row mt-0 mb-2">
                    <div class="col-md-12">
                      <div class="text-center text-muted">
                        <p [innerHTML]="this.subtituloResultadoPesquisa"></p>
                      </div>
                    </div>
                  </div>

                  <div class="box-table mb-3" style="min-height: 240; max-height: 240px">
                    <table class="table-striped" *ngIf="this.results?.length > 0">
                      <thead>
                        <tr>
                          <th>Nº documento</th>
                          <th>Data/Hora entrada</th>
                          <th>Codigo</th>
                          <th>Descricao Material</th>
                          <th>Quantidade</th>
                          <th>Valor</th>
                          <th>Saldo pós entrada</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of this.results">
                          <td class="text-center">{{ item.numeroDocumento }}</td>
                          <td class="text-center">
                            {{ item.dataHoraEntrada | date: "dd/MM/yyyy HH:mm" }}
                          </td>
                          <td class="text-center">{{ item.codigo }}</td>
                          <td class="text-center">{{ item.descricaoMaterial }}</td>
                          <td class="text-center">{{ item.quantidade }}</td>
                          <td class="text-center">{{ item.valor }}</td>
                          <td class="text-center">{{ item.saldoCalculado }}</td>
                        </tr>

                      </tbody>
                    </table>
                  </div>

                  <div class="row" *ngIf="this.results?.length > 0">
                    <div class="col-md-6">
                      <p class="pl-2 mb-0 fb pt-2">
                        {{ this.results?.length }} Entradas listadas
                      </p>
                    </div>
                    <div class="col-md-3"></div>
                    <div class="col-md-3">
                      <button type="button" class="btn btn-light btn-block" (click)="exportarToExcel()"
                        [disabled]="this.results.length == 0"
                        title="Gera uma planilha Excel com os dados apresentados na grid">
                        <span class="fa fa-table txt-green"></span>
                        <span class="pl-4 pr-2">Exportar Excel</span>
                      </button>
                    </div>
                  </div>



                </fieldset>
              </div>
            </div>
          </section>
        </section>
      </div>
      <!-- // box-body-->
    </div>
  </div>
</div>

<app-footer-page></app-footer-page>